import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    notifications: null,
    numberUnClicked: 0,
  },
  reducers: {
    addNotification: (state, action) => {
      state.notifications = action.payload;
    },
    updateUnClickedNumberNotification: (state, action) => {
      state.numberUnClicked = action.payload;
    },
    clearNotifications: (state) => {
      state.notifications = null;
    },
  },
});

export const {
  addNotification,
  updateUnClickedNumberNotification,
  clearNotifications,
} = notificationSlice.actions;

export const getNotifications = (state) => state.notifications;

export const getUnClickedNotification = (state) =>
  state.notifications.numberUnClicked;

export default notificationSlice.reducer;
